var _textTools = this;
this.parseTitle = (name, type) => {
  if(!name || name.trim() === ''){
    return 'Untitled ' + type;
  }
  return name.trim();
}
this.getActionText = (action, chpObjects) => {
  if(action.customText){
    return action.text;
  }
  if(action.baseObj){
    if(action.resultInventoryObj){
      return 'You obtained: ' + chpObjects[action.resultInventoryObj].name; 
    }
    if(action.baseObj && !action.resultInventoryObj){
      return 'You used: ' + chpObjects[action.baseObj].name;
    }
  }
  return '';
}

export default{
  name: 'TextTools',
  parseTitle: this.parseTitle,
  getActionText: this.getActionText
}



// WEBPACK FOOTER //
// ./C:/Git/adventify-vuefire/src/components/TextTools.js